export const APP_VERSION = "1.0.7-a";
export const LAST_UPDATE = new Date("2026-10-07");
